(()=>{'use strict';
const btn=document.querySelector('.page-menu-btn'),menu=document.querySelector('.page-menu'),close=document.querySelector('.page-menu-close'),m=document.querySelector('.page-monkey');
if(btn&&menu)btn.addEventListener('click',()=>menu.classList.add('open'));
if(close&&menu)close.addEventListener('click',()=>menu.classList.remove('open'));
if(!m)return;

const initialSrc=m.getAttribute('src')||m.src;
const frames=[
 initialSrc,
 initialSrc.replace(/odd-oddx-idle\.png(?:\?.*)?$/,'odd-oddx-walk-1.png'),
 initialSrc,
 initialSrc.replace(/odd-oddx-idle\.png(?:\?.*)?$/,'odd-oddx-walk-2.png')
];
const START=-72,DESKTOP_CHECKPOINT=166,MOBILE_CHECKPOINT=109,SPEED=330;
const checkpoint=()=>window.matchMedia('(max-width:700px)').matches?MOBILE_CHECKPOINT:DESKTOP_CHECKPOINT;
let CHECKPOINT=checkpoint();
let x=START,target=CHECKPOINT,moving=true,arrived=false,returning=false,fi=0,fa=0,last=performance.now();
requestAnimationFrame(()=>{CHECKPOINT=checkpoint();target=CHECKPOINT;draw();});
function draw(){m.style.setProperty('left',Math.round(x)+'px','important')}
window.addEventListener('resize',()=>{const next=checkpoint();if(!moving&&arrived){CHECKPOINT=next;x=CHECKPOINT;draw()}else CHECKPOINT=next;});
function walkFrame(dt){fa+=dt;if(fa>=.09){fa=0;fi=(fi+1)%frames.length;m.src=frames[fi]}}
function tick(now){
 const dt=Math.min(.04,(now-last)/1000);last=now;
 if(moving){
  const dx=target-x,step=SPEED*dt;
  if(Math.abs(dx)<=step){
   x=target;moving=false;m.src=frames[0];draw();
   if(returning&&x===START){
    if(window.location.pathname==='/pages/supremes'||(window.location.pathname==='/'&&/^(www\.)?supremes\.club$/.test(window.location.hostname))){
      sessionStorage.setItem('oddworxReturn',JSON.stringify({cur:'C',x:1364,y:297,pitSide:'map'}));
    }
    window.location.assign('/?map=1');return
   }
   if(x===CHECKPOINT)arrived=true;
  }else{x+=Math.sign(dx)*step;walkFrame(dt);draw()}
 }
 requestAnimationFrame(tick)
}
function goBack(){if(!arrived||moving)return;arrived=false;returning=true;target=START;moving=true}
function goCheckpoint(){if(returning&&moving){returning=false;target=CHECKPOINT;moving=true}}
m.setAttribute('role','button');m.setAttribute('aria-label','Return to map');m.tabIndex=0;m.style.cursor='pointer';
m.addEventListener('pointerup',e=>{e.preventDefault();e.stopPropagation();goBack()});
m.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();e.stopPropagation();goBack()}},true);
document.addEventListener('keydown',e=>{
 const tag=(e.target&&e.target.tagName||'').toLowerCase();if(['input','textarea','select'].includes(tag)||e.target?.isContentEditable)return;
 if(e.key==='Escape'&&menu){menu.classList.remove('open');return}
 const k=String(e.key).toLowerCase();
 if(e.key==='ArrowLeft'||k==='a'){e.preventDefault();goBack()}
 if(e.key==='ArrowRight'||k==='d'){e.preventDefault();goCheckpoint()}
},{capture:true});
draw();requestAnimationFrame(tick);
})();

document.addEventListener('click',e=>{
 const top=e.target.closest('.collections-toggle');
 if(top){
   e.preventDefault();e.stopPropagation();
   const sub=top.nextElementSibling;
   if(sub&&sub.classList.contains('collections-submenu')){
     const open=sub.classList.toggle('open');
     top.setAttribute('aria-expanded',String(open));
     const mark=top.querySelector('span');if(mark)mark.textContent=open?'−':'+';
   }
   return;
 }
 const foot=e.target.closest('.footer-collections-toggle');
 if(foot){
   e.preventDefault();e.stopPropagation();
   const sub=foot.parentElement.querySelector('.footer-submenu');
   if(sub){
     const open=sub.classList.toggle('open');
     foot.setAttribute('aria-expanded',String(open));
     const mark=foot.querySelector('span');if(mark)mark.textContent=open?'−':'+';
   }
 }
});


(()=>{const go=(sel,url)=>document.querySelectorAll(sel).forEach(b=>{b.onclick=e=>{e.preventDefault();location.href=url}});go('.search-icon','/search?view=oddworx-search');go('.account-icon','/account?oddworx=1');go('.cart-icon','/cart?view=oddworx-cart');const updateCart=()=>fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json()).then(c=>document.querySelectorAll('.cart-count').forEach(el=>{el.textContent=c.item_count||0;el.hidden=!c.item_count})).catch(()=>{});updateCart();document.addEventListener('visibilitychange',()=>{if(!document.hidden)updateCart()});window.addEventListener('pageshow',updateCart);})();



